<script>
import {
  computed, defineComponent, ref,
} from '@vue/composition-api';
import groupBy from 'lodash.groupby';
import { useCampaignsStats } from '../../composables/useCampaignStats';
import { useManagerDashboard } from '../../composables/useManagerDashboard';

export default defineComponent({
  setup() {
    const { stats } = useCampaignsStats();
    const {
      currentCampaign, formatNumber, storeSelectedCampaignResults: storeSelected,
    } = useManagerDashboard();
    const panel = ref([]);

    const statsByStore = computed(() => {
      if (stats.value && stats.value.length > 0) {
        const found = stats.value.find((el) => el[0].campaignId === currentCampaign.value.id);
        if (found) {
          const statsGrouped = groupBy(found, 'storeId');
          const result = {};
          Object.keys(statsGrouped).filter((el) => storeSelected.value.id.includes(el)).forEach((key) => {
            const storeStats = statsGrouped[key];
            storeStats.sort((a, b) => (a.sent / a.total) - (b.sent / b.total));
            const contactsResult = storeStats.reduce((sum, val) => ({
              sent: sum.sent + val.sent,
              total: sum.total + val.total,
            }));
            if (key !== 'undefined') {
              const storeName = storeStats[0].store;
              result[storeName] = {};
              result[storeName].contactsResult = contactsResult;
              result[storeName].sellers = storeStats;
            }
          });
          return result;
        }
      }
      return null;
    });

    return {
      panel,
      statsByStore,
      formatNumber,
    };
  },
});
</script>

<template>
  <div>
    <v-expansion-panel
      v-model="panel"
      expand
    >
      <v-expansion-panel-content
        v-for="(storeName, i) in Object.keys(statsByStore)"
        :key="i"
        class="mb-2 py-2 px-3 content"
      >
        <template #actions>
          <v-icon :color="panel[i] ? '#099AB1' : null">
            $vuetify.icons.expand
          </v-icon>
        </template>
        <template #header>
          <v-container
            class="py-2 px-0"
            :style="panel[i] ? {'border-bottom': '1px solid #DDDDDD', 'margin-bottom': '20px'} : {}"
          >
            <div
              class="title"
            >
              {{ storeName }}
            </div>
            <div
              v-show="panel[i]"
              class="title__contact-sent"
            >
              {{ statsByStore[storeName].contactsResult.sent }} contatos de {{ statsByStore[storeName].contactsResult.total }} contatos
            </div>
          </v-container>
        </template>
        <v-card
          v-for="(sellerResult) in statsByStore[storeName].sellers"
          :key="sellerResult.seller"
        >
          <div class="seller__name">
            {{ sellerResult.seller }}
          </div>
          <v-layout
            row
            wrap
          >
            <v-flex
              class="seller__result"
              grow
            >
              {{ formatNumber(sellerResult.sent) }} de {{ formatNumber(sellerResult.total) }} contatos
            </v-flex>
            <v-flex
              shrink
              :style="{'color' : sellerResult.sent/sellerResult.total < 0.7 ? '#FF5146' : '#6ADDC8'}"
              class="seller__result"
            >
              {{ Math.floor(sellerResult.sent / sellerResult.total * 100) }} %
            </v-flex>
          </v-layout>
          <v-progress-linear
            :color="sellerResult.sent/sellerResult.total < 0.7 ? '#FF5146' : '#6ADDC8'"
            background-color="#DDDDDD"
            height="7"
            :value="formatNumber(sellerResult.sent/sellerResult.total * 100)"
          />
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<style lang="scss" scoped>
.content {
border-radius: 5px !important;
box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
}
.title {
  font-style: normal;
  font-family: 'Nunito Sans' !important;
  font-weight: normal;
  font-size: 12px !important;
  line-height: 14px;
  &__contact-sent {
    font-style: normal;
    font-family: 'Nunito Sans' !important;
    font-weight: normal;
    font-size: 8px !important;
    line-height: 11px;
  }
}
::v-deep .v-expansion-panel__header {
  border-top: 0px;
  padding-left: 0px !important;
}
.seller {
  &__name {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
  }
  &__result {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 8px !important;
    line-height: 11px;
  }
}
::v-deep .v-expansion-panel {
  font-size: 12pt;
}
::v-deep .v-expansion-panel__container {
  font-size: 12pt;
  box-shadow: 0 3px rgb(0 0 0 / 0.05);
  border-radius: 0px;
}

::v-deep .v-expansion-panel__body > .v-card {
  border-right: 0px !important;
}
::v-deep .v-expansion-panel__header {
  border-top: 0px;
  padding: 0 10px 0 10px;
}
::v-deep .v-progress-linear {
  border-radius: 16px !important;
}
</style>
